<template>
  <div class="row">
    <div class="col-lg-12">
      <div>
        <div class="card-body">
          <div class="card-body-form">
            <h2 class="qa_title" style="margin-bottom: 20px">
              {{ item.title }}
            </h2>
            <div class="qa_score">
              <span style="margin-right: 20px">
                当前题数:&nbsp;<span v-if="subList.generateType == 0">
                  {{
                    subList.singleNum +
                      subList.multipleNum +
                      subList.judgeNum +
                      subList.sortNum +
                      subList.singleBlankNum +
                      subList.multipleBlankNum
                  }}
                </span>
                <span v-else>
                  {{ currentTopic.length }}
                </span>
              </span>
              <span> 当前总分:&nbsp;{{ item.score }} </span>
            </div>
            <!-- 信息收集 -->
            <div style="padding: 0px 10px">
              <div class="text_st">
                <span>信息收集</span>
                <el-button
                  size="mini"
                  style="margin-left: 20px"
                  @click="addInfo()"
                  >添加
                </el-button>
              </div>
              <div style="margin-bottom: 20px" class="row">
                <vuedraggable
                  v-model="infoList"
                  animation="300"
                  handle=".mover"
                >
                  <div
                    v-for="(item, index) in infoList"
                    :key="index"
                    class="col-md-12"
                  >
                    <label
                      ><span v-if="item.isMust" style="color: red"> * </span>
                      {{ item.title }}</label
                    >
                    <div class="flex">
                      <div
                        class="mb-3 flex"
                        style="align-items: center; min-width: 600px"
                      >
                        <input
                          v-if="item.option == ''"
                          type="text"
                          class="form-control"
                          maxlength="30"
                        />
                        <el-select
                          v-model="checkOption"
                          style="width: 100%"
                          v-else
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="data in item.selectOptions"
                            :key="data.value"
                            :label="data.label"
                            :value="data.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div
                        class="mb-3 flex"
                        style="min-width: 255px; align-items: center"
                      >
                        <el-button
                          type="primary"
                          size="mini"
                          style="margin-left: 20px"
                          @click="editInfo(item, index)"
                          >编辑
                        </el-button>
                        <el-button
                          type="danger"
                          size="mini"
                          style="margin-left: 20px"
                          @click="removeInfo(index)"
                          >删除</el-button
                        >
                        <el-checkbox
                          style="margin: 0 0; margin-left: 20px"
                          v-model="item.isMust"
                          >必填</el-checkbox
                        >
                        <i
                          style="font-size: 20px; margin-left: 20px"
                          class="bx bx-move mover"
                        ></i>
                      </div>
                    </div>
                  </div>
                </vuedraggable>
              </div>
            </div>
            <div class="row submit-bar"></div>
            <!-- 题目设置 -->
            <div style="padding: 0px 10px; margin-bottom: 20px">
              <div class="text_st">题目设置</div>
              <div style="margin-bottom: 20px">
                <el-radio-group
                  @change="updateType"
                  v-model="subList.generateType"
                >
                  <el-radio :label="0">随机生成</el-radio>
                  <el-radio :label="1">指定获取</el-radio>
                </el-radio-group>
              </div>
              <!-- 随机生成 -->
              <span v-if="subList.generateType == 0">
                <el-form
                  label-position="left"
                  :model="subList"
                  ref="numberValidateForm"
                  label-width="100px"
                  class="demo-ruleForm"
                >
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="单选题"
                      prop="singleNum"
                      :rules="[
                        { type: 'number', message: '单选题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.singleNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="多选题"
                      prop="multipleNum"
                      :rules="[
                        { type: 'number', message: '多选题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.multipleNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="判断题"
                      prop="judgeNum"
                      :rules="[
                        { type: 'number', message: '判断题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.judgeNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="排序题"
                      prop="sortNum"
                      :rules="[
                        { type: 'number', message: '排序题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.sortNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="单项填空题"
                      prop="singleBlankNum"
                      :rules="[
                        { type: 'number', message: '单项填空题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.singleBlankNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                  <div style="margin-bottom: 30px">
                    <el-form-item
                      label="多项填空题"
                      prop="multipleBlankNum"
                      :rules="[
                        { type: 'number', message: '多项填空题必须为数字值' },
                      ]"
                    >
                      <el-input
                        style="width: 120px"
                        v-model.number="subList.multipleBlankNum"
                      >
                        <template slot="append">题</template></el-input
                      >
                    </el-form-item>
                  </div>
                </el-form>
              </span>
              <!-- 指定获取 -->
              <div v-else class="col-md-12">
                <!-- <div class="mb-3">
                  <label>题目列表：&emsp;</label>
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-20"
                    @click="openTopicDialog()"
                  >
                    添加
                  </button>
                  <button
                    type="button"
                    class="btn-sm btn btn-danger m-r-10"
                    @click="removeTopics()"
                  >
                    批量删除
                  </button>
                </div> -->
                <!-- <div class="table-responsive-main-list">
                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 70px">
                            <b-form-checkbox
                              @change="checkedAll"
                              v-model="indeterminate"
                              checked
                              plain
                            ></b-form-checkbox>
                          </th>
                          <th scope="col" style="width: 70px">ID</th>
                          <th scope="col">题目标题</th>
                          <th scope="col">题目类型</th>
                          <th scope="col">状态</th>
                          <th scope="col">创建人</th>
                          <th scope="col">更新时间</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <vuedraggable
                        tag="tbody"
                        v-model="currentTopic"
                        animation="300"
                        handle=".mover"
                      >
                        <tr
                          v-for="(data, index) in currentTopic"
                          :key="data.id"
                        >
                          <td class="media-dialog-radio">
                            <b-form-checkbox
                              v-model="selectTopic"
                              :value="data"
                              checked
                              plain
                            ></b-form-checkbox>
                          </td>
                          <td>{{ data.id }}</td>
                          <td>{{ data.title || "--" }}</td>
                          <td>{{ checkType(data.type) }}</td>
                          <td>
                            <span
                              v-if="data.state == 1"
                              class="dsply-fix status-open"
                              ><i></i>启用</span
                            >
                            <span
                              v-if="data.state == 0"
                              class="dsply-fix status-off"
                              ><i></i>禁用</span
                            >
                          </td>

                          <td>
                            {{ data.creator || "--" }}
                          </td>
                          <td>
                            {{ data.updatedAt || "--" }}
                          </td>
                          <td>
                            <span class="flex" style="align-items: center">
                              <button
                                @click="removeTopic(index)"
                                style="margin-right: 10px"
                                type="button"
                                class="btn-sm btn btn-danger"
                              >
                                移除
                              </button>
                              <i
                                style="font-size: 20px"
                                class="bx bx-move mover"
                              ></i>
                            </span>
                          </td>
                        </tr>
                        <tr v-if="!currentTopic[0]">
                          <td colspan="8" style="text-align: center">
                            暂无数据
                          </td>
                        </tr>
                      </vuedraggable>
                    </table>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="row submit-bar"></div>
            <!-- 题目列表 -->
            <div class="mb-3" v-show="subList.generateType == 1">
              <div class="text_st">题目列表</div>
              <div class="mb-3">
                <button
                  type="button"
                  class="btn-sm btn btn-primary m-r-20"
                  @click="openTopicDialog()"
                >
                  添加
                </button>
                <button
                  type="button"
                  class="btn-sm btn btn-primary m-r-20"
                  @click="openImportDialog()"
                >
                  批量导入
                </button>
                <button
                  type="button"
                  class="btn-sm btn btn-primary m-r-20"
                  @click="addTopic()"
                >
                  新建题目
                </button>
                <!-- <button
                  type="button"
                  class="btn-sm btn btn-danger m-r-10"
                  @click="removeTopics()"
                >
                  批量删除
                </button> -->
              </div>
              <div class="table-responsive-main-list">
                <div class="table-responsive">
                  <table class="table align-middle table-nowrap table-hover">
                    <thead class="table-light">
                      <tr>
                        <th scope="col" style="width: 70px">
                          <b-form-checkbox
                            @change="checkedAll"
                            v-model="indeterminate"
                            checked
                            plain
                          ></b-form-checkbox>
                        </th>
                        <th scope="col" style="width: 70px">ID</th>
                        <th scope="col">题目标题</th>
                        <th scope="col">题目类型</th>
                        <th scope="col">状态</th>
                        <th scope="col">创建人</th>
                        <th scope="col">更新时间</th>
                        <th scope="col">操作</th>
                      </tr>
                    </thead>
                    <vuedraggable
                      @end="sortItems"
                      tag="tbody"
                      v-model="currentTopic"
                      animation="300"
                      handle=".mover"
                    >
                      <tr v-for="data in currentTopic" :key="data.id">
                        <td class="media-dialog-radio">
                          <b-form-checkbox
                            v-model="selectTopic"
                            :value="data"
                            checked
                            plain
                          ></b-form-checkbox>
                        </td>
                        <td>{{ data.id }}</td>
                        <td class="w-450px white-inherit">
                          {{ data.title || "--" }}
                        </td>
                        <td>{{ checkType(data.type) }}</td>
                        <td>
                          <el-tooltip
                            :content="data.style == 1 ? '点击隐藏' : '点击显示'"
                          >
                            <span
                              @click="modifyStatus(data, '0')"
                              v-if="data.state == 1"
                              class="dsply-fix status-open"
                              ><i></i>显示</span
                            >
                            <span
                              @click="modifyStatus(data, '1')"
                              v-if="data.state == 0"
                              class="dsply-fix status-off"
                              ><i></i>隐藏</span
                            >
                          </el-tooltip>
                          <!-- <span
                            v-if="data.state == 1"
                            class="dsply-fix status-open"
                            ><i></i>启用</span
                          >
                          <span
                            v-if="data.state == 0"
                            class="dsply-fix status-off"
                            ><i></i>禁用</span
                          > -->
                        </td>

                        <td>
                          {{ data.creator || "--" }}
                        </td>
                        <td>
                          {{ data.updatedAt || "--" }}
                        </td>
                        <td>
                          <span class="flex" style="align-items: center">
                            <button
                              @click="editTopic(data)"
                              style="margin-right: 10px"
                              type="button"
                              class="btn-sm btn btn-primary m-r-10"
                            >
                              编辑
                            </button>
                            <button
                              @click="removeTopic(data)"
                              style="margin-right: 10px"
                              type="button"
                              class="btn-sm btn btn-danger m-r-10"
                            >
                              移除
                            </button>
                            <i
                              style="font-size: 20px"
                              class="bx bx-move mover"
                            ></i>
                          </span>
                        </td>
                      </tr>
                    </vuedraggable>
                  </table>
                </div>
                <app-list-loading ref="loading"></app-list-loading>

                <pagination
                  :batchs="batchs"
                  ref="page"
                  @pageCallback="pageCallback"
                ></pagination>
              </div>
            </div>
            <!-- 底部 取消保存 -->
            <div class="row submit-bar" style="padding-top:15px">
              <div class="col-md-12">
                <div class="bar-handle" style="margin-bottom:15px">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button>
                  <button
                    @click="subInfo()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    <span> 保存 </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 修改标题 -->
        <el-dialog top="1vh" :visible.sync="dialogVisible" width="45%">
          <el-form
            label-position="left"
            label-width="110px"
            :model="formLabelAlign"
            :rules="rules"
            ref="formLabelAlign"
          >
            <el-form-item label="信息收集标题" prop="title">
              <el-input
                style="width: 60%"
                v-model="formLabelAlign.title"
              ></el-input>
              <el-checkbox
                style="margin-left: 1rem"
                v-model="formLabelAlign.isMust"
                >必填</el-checkbox
              >
            </el-form-item>
            <el-form-item label="">
              <el-radio-group v-model="infoType">
                <el-radio label="input">输入框</el-radio>
                <el-radio label="option">选项框</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <el-input
                v-if="infoType == 'input'"
                style="width: 60%"
              ></el-input>
              <el-input
                type="textarea"
                resize="none"
                :rows="5"
                v-if="infoType == 'option'"
                style="width: 60%"
                v-model="formLabelAlign.option"
              ></el-input>
              <div
                v-show="infoType == 'option'"
                style="color: #999; font-size: 12px"
              >
                填入所有下拉选项，以 | 分隔
              </div>
            </el-form-item>
          </el-form>
          <!-- <span>信息收集标题</span>
          <el-input
            style="margin-top: 10px"
            v-model="editTitle.name"
            placeholder="请输入内容"
          ></el-input> -->
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false"
              >取 消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="subInfoTitle('formLabelAlign')"
              >确 定</el-button
            >
          </span>
        </el-dialog>
        <!-- 添加题目 -->
        <topicDialog @pageCallback="pageCallback" ref="topic"></topicDialog>
        <!-- 新建题目 -->
        <newTopicDialog
          @pageCallback="pageCallback"
          ref="newTopic"
        ></newTopicDialog>
        <!-- 批量导入弹窗 -->
        <el-dialog :visible.sync="importDialog" width="30%">
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <el-button v-if="this.excelFile.name" size="small" type="primary">{{
              this.excelFile.name
            }}</el-button>
            <upload-button
              v-else
              type="excel"
              :isFile="true"
              @onSuccess="uploadSuccess"
            ></upload-button>

            <div
              style="
                font-size: 12px;
                color: #ccc;
                margin-top: 8px;
                margin-bottom: 8px;
              "
            >
              通过上传Excel文件批量导入
            </div>
            <el-link
              @click="onDownloadClick"
              style="font-size: 12px; color: #ccc"
              >模板下载</el-link
            >
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="importDialog = false"
              >取 消</el-button
            >
            <el-button
              :disabled="uploadExcelFlag"
              size="mini"
              type="primary"
              @click="submitImport"
              ><span v-if="!uploadExcelFlag">确 定</span>
              <span v-else
                ><i class="el-icon-loading"></i> 导入中</span
              ></el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import vuedraggable from "vuedraggable";
import topicDialog from "./topicListDiaog.vue";
import question from "@/server/api/question";
import pagination from "@/components/pagination/pagination.vue";
import newTopicDialog from "./newTopicDialog.vue";
import { getSortParams } from "@/util/fun.js";

export default {
  components: {
    vuedraggable,
    topicDialog,
    newTopicDialog,
    pagination,
  },
  data() {
    return {
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "移除", value: "1" },
      ],
      relationListPage: {
        id: null,
        page: 1,
        pageSize: 30,
        questionnaireId: "",
      },
      checkOption: "",
      infoOptions: [],
      editInfoIndex: null,
      infoType: "input",
      rules: {
        title: [
          { required: true, message: "请输入信息收集标题", trigger: "blur" },
        ],
      },
      formLabelAlign: {
        name: "",
        option: "",
        isMust: null,
      },
      index_id: null,
      subList: {
        generateType: 0, //题目生成方式,0-随机,1-指定
        singleNum: 0, //单选题数量
        multipleNum: 0, //多选题数量
        judgeNum: 0, //判断题数量
        sortNum: 0, //排序题数量
        singleBlankNum: 0, //单项填空数量
        multipleBlankNum: 0, //多项填空数量
      },
      infoList: [{ title: "你的姓名", isMust: false }],
      checked: false,
      dialogVisible: false,
      editTitle: { name: "", index: "" },
      topicRadio: "1",
      topicTypeList: [
        {
          label: "单选",
          value: "1",
          num: null,
        },
        {
          label: "多选",
          value: "2",
          num: null,
        },
        {
          label: "判断",
          value: "3",
          num: null,
        },
        {
          label: "填空",
          value: "4",
          num: null,
        },
        {
          label: "多选填空",
          value: "5",
          num: null,
        },
      ],
      currentTopic: [],
      currentVideos: [],
      qaMinutes: "",
      qaSeconds: "",
      longTime: true,
      timerValue: [],
      selectTopic: [],
      indeterminate: false, //全选
      item: {
        score: 0,
      },
      importDialog: false,
      excelFile: "",
      uploadExcelFlag: false,
    };
  },

  mounted() {
    // 获取详情
    this.index_id = this.$route.query.id;
    this.fetch();
    this.getTopicList();
  },

  methods: {
    onDownloadClick() {
      // console.log("下载");
      const link = document.createElement("a");
      // 规定下载的超链接
      link.download = "题目导入模板.xlsx";
      // 未点击前隐藏a链接
      link.style.display = "none";
      // 创建URL对象，指向该文件url
      link.href = "/fileResources/topictest.xlsx";
      // 将a标签添加到dom中
      document.body.append(link);
      // 触发a标签点击事件
      link.click();
      // 释放之前的URL对象
      URL.revokeObjectURL(link.href);
      // 从dom中移除该a链接
      document.body.removeChild(link);
    },
    sortItems() {
      let obj = getSortParams(
        this.bfTopicList,
        this.currentTopic,
        "sort",
        "sort",
        "id"
      );
      let params = obj.params;
      question.relationSort(params).then((res) => {
        if (res.code == 0) {
          this.getTopicList();
        } else {
          Vue.swal(res.msg);
        }
      });
    },
    getTopicList() {
      this.relationListPage.id = Number(this.index_id);
      let params = this.utils.getQuery(this.relationListPage);
      this.$refs.loading.show();
      // this.currentTopic = [];
      question.relationList(params).then((res) => {
        if (res.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(res.data.items);
          }
          this.indeterminate = false;
          this.selectTopic = [];
          this.currentTopic = res.data.items;
          this.bfTopicList = JSON.parse(JSON.stringify(res.data.items));
          let pages = {
            page: res.data.page, //第几页
            pageSize: res.data.pageSize, //每页多少条
            total: res.data.total, //全部有多少条数据
            totalPages: res.data.totalPages, //全部有几页
          };
          // 获取列表后调用组件的方法传入分页信息
          this.$nextTick(() => {
            if (this.$refs.page) {
              this.$refs.page.setPages(pages);
            }
          });
        }
      });
    },
    fetch() {
      let params = { id: this.index_id };
      question.detail(params).then((resp) => {
        if (resp.code == 0) {
          // console.log(resp.data);
          this.item = resp.data;
          // this.$refs.coverImg.setImageUrl(this.item.cover);
          this.qaMinutes = this.formatSeconds(this.item.time).min;
          this.qaSeconds = this.formatSeconds(this.item.time).s;
          if (this.item.endTime == "2033-01-01 00:00:01") {
            this.longTime = true;
          }
          this.timerValue = [this.item.startTime, this.item.endTime];
          this.item.state = this.item.state + "";
          this.subList.generateType = this.item.generateType;
          this.subList.singleNum = this.item.singleNum;
          this.subList.multipleNum = this.item.multipleNum;
          this.subList.judgeNum = this.item.judgeNum;
          this.subList.sortNum = this.item.sortNum;
          this.subList.singleBlankNum = this.item.singleBlankNum;
          this.subList.multipleBlankNum = this.item.multipleBlankNum;
          // this.currentTopic = this.item.questions;
          //      subList: {
          //   generateType: 0, //题目生成方式,0-随机,1-指定
          //   singleNum: 0, //单选题数量
          //   multipleNum: 0, //多选题数量
          //   judgeNum: 0, //判断题数量
          //   singleBlankNum: 0, //单项填空数量
          //   multipleBlankNum: 0, //多项填空数量
          // },

          this.infoList = this.item.infos.map((v) => {
            const arr = v.option.split("|");
            const selectOptionsList = arr.map((v, i) => {
              return { value: i, label: v };
            });
            return {
              id: v.id,
              isMust: v.isMust == 1 ? true : false,
              title: v.title,
              option: v.option,
              selectOptions: v.option == "" ? [] : selectOptionsList,
            };
          });
        }
      });
    },
    //秒转 分 秒
    formatSeconds(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? +Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = { min: m, s: s };
      return res;
    },
    addInfo() {
      let item = { title: "你的姓名", isMust: false, option: "" };
      this.infoList.push(item);
    },
    editInfo(item, i) {
      this.formLabelAlign = JSON.parse(JSON.stringify(item));
      this.editInfoIndex = i;
      if (item.option != "") {
        this.infoType = "option";
      } else {
        this.infoType = "input";
      }
      this.dialogVisible = true;
    },
    subInfoTitle(item) {
      this.$refs[item].validate((valid) => {
        if (valid) {
          this.infoList[this.editInfoIndex].title = this.formLabelAlign.title;
          this.infoList[this.editInfoIndex].isMust = this.formLabelAlign.isMust;
          if (this.infoType == "input") {
            this.infoList[this.editInfoIndex].option = "";
          } else {
            this.infoList[
              this.editInfoIndex
            ].option = this.formLabelAlign.option;

            const arr = this.formLabelAlign.option.split("|");
            this.infoList[this.editInfoIndex].selectOptions = arr.map(
              (v, i) => {
                return { value: i, label: v };
              }
            );
          }
          // this.$set(this.infoList[this.editInfoIndex].selectOptions, this.editInfoIndex, this.formLabelAlign);
          this.formLabelAlign = this.$options.data.call(this).formLabelAlign;
          this.dialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    removeInfo(i) {
      this.infoList.splice(i, 1);
    },

    goBack() {
      this.$router.go(-1);
    },
    openTopicDialog() {
      this.$refs.topic.showModel(this.index_id);
    },
    addTopic() {
      this.$refs.newTopic.showModel();
    },
    openImportDialog() {
      this.excelFile = "";
      this.importDialog = true;
      this.uploadExcelFlag = false;
    },
    uploadSuccess(file) {
      console.log(file);
      if (file) {
        this.excelFile = file;
      }
    },
    submitImport() {
      this.uploadExcelFlag = true;
      if (this.excelFile) {
        question.questionImport(this.excelFile).then((res) => {
          if (res.code == 0) {
            Vue.swal({
              icon: "success",
              title: "导入成功",
              showConfirmButton: false,
              timer: 1000,
            });
            this.uploadExcelFlag = false;
            this.importDialog = false;
            let params = { code: "topic", item: res.data };
            this.pageCallback(params);
          }
        });
      } else {
        Vue.swal("请导入文件");
        this.uploadExcelFlag = false;
      }
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        if (obj.ps == 100) {
          this.relationListPage.pageSize = 100;
          this.getTopicList();
        } else if (obj.ps == 50) {
          this.relationListPage.pageSize = 50;
          this.getTopicList();
        } else {
          this.relationListPage.pageSize = 30;
          this.getTopicList();
        }
      }
      if (obj.code === "page") {
        //更改页码
        this.relationListPage.page = obj.page;
        this.getTopicList();
      }
      if (obj.code === "batch") {
        if (this.selectTopic.length == 0) {
          this.warning("未选择数据");
          return;
        }
        if (obj.batch == 1) {
          const arr = this.selectTopic.map((v, i) => {
            return v.id;
          });
          question.relationDelete(arr).then((res) => {
            if (res.code == 0) {
              Vue.swal({
                icon: "success",
                title: "操作成功",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getTopicList();
            } else {
              Vue.swal(res.msg);
            }
          });
          // this.modifyStatus("batch", 1);
        }
      } //处理批量操作
      // if (obj.code == "media") {
      //   this.item.userId = obj.item.id;
      //   this.currentMedia = obj.item;
      // }
      // if (obj.code == "video") {
      //   this.currentVideos = this.currentVideos.concat(obj.item);
      //   this.currentVideos = this.utils.fn2(this.currentVideos);
      // }
      if (obj.code == "topic") {
        const arr = obj.item.map((v, i) => {
          return {
            questionId: v.id,
            questionnaireId: Number(this.index_id),
            sort: i,
          };
        });
        // this.currentTopic = this.currentTopic.concat(obj.item);
        // this.currentTopic = this.utils.fn2(this.currentTopic);
        question.relationAdd(arr).then((res) => {
          if (res.code == 0) {
            this.getTopicList();
          }
        });
      }
      if (obj.code == "questionTopic") {
        question
          .relationAdd([
            { questionId: obj.item, questionnaireId: this.index_id },
          ])
          .then((res) => {
            if (res.code == 0) {
              Vue.swal({
                icon: "success",
                title: "题目添加成功",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getTopicList();
            } else {
              Vue.swal("添加失敗");
            }
          });
      }

      // //创建题后关联到问卷
      // relationTopic(id) {
      //   // this.currentTopic = this.currentTopic.concat(obj.item);
      //   // this.currentTopic = this.utils.fn2(this.currentTopic);
      //   question
      //     .relationAdd([{ questionId: id, questionnaireId: this.index_id }])
      //     .then((res) => {
      //       if (res.code == 0) {
      //         // this.getTopicList();
      //       } else {
      //         Vue.swal("添加失敗");
      //       }
      //     });
      // },

      // console.log(obj);
    },

    //提交信息
    subInfo() {
      let usList = JSON.parse(JSON.stringify(this.infoList));
      usList.forEach((v, i) => {
        v.isMust = v.isMust ? 1 : 0;
      });
      usList.forEach((v, i) => {
        v.sort = i;
      });
      let params = this.subList;
      params.infos = usList;
      params.title = this.item.title;
      params.cover = this.item.cover;
      params.time = this.item.time;
      params.startTime = this.item.startTime;
      params.endTime = this.item.endTime;
      params.allowCount = this.item.allowCount;
      params.state = Number(this.item.state);
      params.id = this.item.id;
      params.dailyCount = this.item.dailyCount;


      //随机提交
      if (params.generateType == 0) {
        params.questions = [];
        // {
        //   judgeNum: 0;
        //   multipleBlankNum: 0;
        //   multipleNum: 0;
        //   questions: [];
        //   singleBlankNum: 0;
        //   singleNum: 0;
        // }
        if (params.singleNum === "") {
          Vue.swal("单选题不能为空");
          return;
        }
        if (params.multipleNum === "") {
          Vue.swal("多选题不能为空");
          return;
        }
        if (params.judgeNum === "") {
          Vue.swal("判断题不能为空");
          return;
        }
        if (params.sortNum === "") {
          Vue.swal("排序题不能为空");
          return;
        }
        if (params.singleBlankNum === "") {
          Vue.swal("单选题填空不能为空");
          return;
        }
        if (params.multipleBlankNum === "") {
          Vue.swal("多选填空题不能为空");
          return;
        }
      }
      //指定获取
      if (params.generateType == 1) {
        params.questions = JSON.parse(JSON.stringify(this.currentTopic));
        params.questions = params.questions.map((v, i) => {
          return {
            id: v.id,
            caseSensitive: v.caseSensitive,
            casePunctuation: v.casePunctuation,
            state: v.state,
            title: v.title,
            type: v.type,
            sort: i,
            answers: [],
          };
        });
        params.singleNum = 0;
        params.multipleNum = 0;
        params.judgeNum = 0;
        params.sortNum = 0;
        params.singleBlankNum = 0;
        params.multipleBlankNum = 0;
      }
      question.modify(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "操作成功！",
            showConfirmButton: false,
            timer: 1000,
          });
        } else {
          Vue.swal(resp.msg);
        }
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //判断类型
    checkType(num) {
      if (num == 0) {
        return "单选";
      }
      if (num == 1) {
        return "多选";
      }
      if (num == 2) {
        return "判断";
      }
      if (num == 3) {
        return "单项填空";
      }
      if (num == 4) {
        return "多项填空";
      }
      if (num == 5) {
        return "排序";
      }
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.selectTopic = this.currentTopic;
      } else {
        this.selectTopic = [];
      }
    },
    //移除
    removeTopic(item) {
      question.relationDelete([item.id]).then((res) => {
        if (res.code == 0) {
          Vue.swal({
            icon: "success",
            title: "操作成功",
            showConfirmButton: false,
            timer: 1000,
          });
          this.getTopicList();
        } else {
          Vue.swal(res.msg);
        }
      });
      // console.log(i);
      // this.currentTopic.splice(i, 1);
    },
    //编辑
    editTopic(item) {
      this.$refs.newTopic.showModel({
        id: item.questionId,
      });
    },
    // //批量删除
    // removeTopics() {
    //   if (this.selectTopic.length == 0) {
    //     Vue.swal("请选择删除的题目");
    //   } else {
    //     let usArr = JSON.parse(JSON.stringify(this.currentTopic));
    //     for (let i = 0; i < usArr.length; i++) {
    //       for (let k = 0; k < this.selectTopic.length; k++) {
    //         if (usArr[i].id == this.selectTopic[k].id) {
    //           usArr.splice(i, 1);
    //         }
    //       }
    //     }
    //     this.currentTopic = usArr;
    //     this.selectTopic = [];
    //   }
    // },
    //更改题目设置
    updateType(val) {
      // if (val == 1) {
      //   this.subList.singleNum = 0;
      //   this.subList.multipleNum = 0;
      //   this.subList.judgeNum = 0;
      //   this.subList.singleBlankNum = 0;
      //   this.subList.multipleBlankNum = 0;
      // }
    },
    //显示状态
    modifyStatus(item, status) {
      let title_text = status == 1 ? "确定显示？" : "确定隐藏？";
      Swal.fire({
        title: title_text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          console.log(item);
          let params = {
            id: item.questionId,
            title: item.title, //标题
            type: item.type, //封面
            state: Number(status), //0-禁用,1-启用
            caseSensitive: item.caseSensitive,
            casePunctuation: item.casePunctuation,
          };
          question.questionBase(params).then((resp) => {
            if (resp.code == 0) {
              let success_text = status == 1 ? "显示成功" : "隐藏成功";
              Vue.swal({
                icon: "success",
                title: success_text,
                showConfirmButton: false,
                timer: 1000,
              });
              this.getTopicList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.submit-bar {
  margin: 0;
  padding: 0;
}
.el-form-item__label {
  text-align: left;
}
.qa_title {
  padding: 0 44px;
  text-align: center;
}
.qa_score {
  text-align: center;
  padding: 0 44px;
}
.text_st {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  text-align: left;
  margin: 20px 0;
}
.sub_title {
  width: 90px;
  text-align: right;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
